import { useTLang } from 'intl/intl';

import type { TurnOffModeOption } from 'features/mozart-notifications/domain';

export function useMozartTurnOffProductLang() {
  return {
    dialog: {
      header: {
        title: useTLang({ id: 'notification.mozart.043' }),
      },
      action: {
        primaryBtn: useTLang({ id: 'notification.mozart.045' }),
      },
    },
    infoCard: {
      title: useTLang({ id: 'notification.mozart.025' }),
    },
    form: {
      legend: useTLang({ id: 'notification.mozart.013' }),
      option: {
        today: {
          title: useTLang({ id: 'notification.mozart.034' }),
        },
        oneWeek: {
          title: useTLang({ id: 'notification.mozart.038' }),
        },
        manual: {
          title: useTLang({ id: 'notification.mozart.027' }),
        },
      },
    },
    snackBar: {
      success: {
        title: useTLang({ id: 'notification.mozart.018' }),
        msg: {
          DAILY: useTLang({ id: 'notification.mozart.015' }),
          CUSTOM: useTLang({ id: 'notification.mozart.016' }),
          PERMANENT: useTLang({ id: 'notification.mozart.017' }),
        } as Record<TurnOffModeOption, string>,
      },
      error: {
        title: useTLang({ id: 'menuPage.snackBar.turnOffItem.error.title' }),
        msg: useTLang({ id: 'menuPage.snackBar.turnOffItem.error.msg' }),
      },
    },
  };
}
